"use client";

import Modal from "@/components/design-system/modal";
import styles from "./shippingAndSalesTaxModal.module.scss";

export default function ShippingAndSalesTaxModal({ show, onHide }: ShippingAndSalesTaxModalProps) {
  return (
    // Skinny + sizeDownMd keeps the dialog at a flat 480px cap on every breakpoint.
    <Modal show={show} onHide={onHide} title="Shipping & Sales Tax" size="skinny" sizeDownMd="medium">
      <div className={styles.taxInfoBody}>
        <section className={styles.taxInfoSection}>
          <h3 className={styles.taxInfoHeading}>Shipping Fees</h3>
          <p>
            Each vendor charges a standard shipping fee, which includes handling, order processing, item selection,
            packaging, and transportation of items. Additional heavy shipping surcharges may apply to items that are
            heavy or ordered in large quantities.
          </p>
        </section>
        <section className={styles.taxInfoSection}>
          <h3 className={styles.taxInfoHeading}>Sales Tax</h3>
          <p>
            Sales Taxes are estimated for each vendor based on the state to which the items are shipped. Please note
            that the amount of estimated tax appearing on an order may differ from the sales taxes ultimately charged at
            the time of credit card authorization.
          </p>
        </section>
      </div>
    </Modal>
  );
}

export interface ShippingAndSalesTaxModalProps {
  show: boolean;
  onHide: () => void;
}
